import { h, Component } from 'preact';

export default class Survey extends Component {}


// WEBPACK FOOTER //
// ./src/Display/Components/Surveys/Survey.js